<!-- Loading bar -->
<!-- <fuse-loading-bar></fuse-loading-bar> -->
<!-- Navigation -->
<fuse-vertical-navigation
    id="c-nav-container"
    class="dark bg-lsr-900 text-white print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationHeader>
        <!-- Logo -->
        <div class="flex items-center h-20 p-6 pb-0 justify-center">
            <img class="w-100 max-w-42 mr-5" src="assets/images/logo/logo.png" />
        </div>
        <span class="separator-line mt-20px"></span>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationFooter>
        <!-- User -->
        <div
            id="c-user-container"
            class="relative text-right flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden flex-row px-6 py-8 border-t"
        >
            <user [matMenuTriggerFor]="userActions" class="hover:cursor-pointer"></user>
            <div class="flex flex-col w-full ml-4 overflow-hidden">
                <div
                    class="w-full whitespace-nowrap text-ellipsis overflow-hidden leading-normal text-current opacity-80 hover:cursor-pointer text-left"
                    [matMenuTriggerFor]="userActions"
                >
                    {{ userDetails?.user?.nafn }}
                </div>
                @if (userDetails?.user?.kennitala) {
                    <div
                        class="w-full mt-0.5 whitespace-nowrap text-sm text-ellipsis overflow-hidden leading-normal text-current opacity-50 hover:cursor-pointer text-left"
                        [matMenuTriggerFor]="userActions"
                    >
                        kt. {{ formatSsn(userDetails?.user?.kennitala) }}
                    </div>
                }
            </div>
        </div>
        <span class="separator-line block sm:hidden"></span>
        <mat-menu [xPosition]="'before'" #userActions="matMenu">
            <a class="no-underline" routerLink="/stillingar/profill">
                <button mat-menu-item>
                    <span class="flex flex-col leading-none">
                        <span class="mt-1.5 text-md font-medium">{{ userDetails?.user?.nafn }}</span>
                        @if (userDetails) {
                            <span class="mt-1.5 text-sm font-small">kt. {{ formatSsn(userDetails?.user?.kennitala) }}</span>
                        }
                    </span>
                </button>
            </a>
            <ng-container>
                <mat-divider class="my-2"></mat-divider>
                <a class="no-underline" routerLink="/stillingar/profill">
                    <button mat-menu-item>
                        <mat-icon [svgIcon]="'mat_outline:settings'"></mat-icon>
                        <span>{{ 'label_settings' | translate }}</span>
                    </button>
                </a>
                @if (
                    lsrauthService.inRole(userDetails, userRoles.SYSTEM_SETTINGS) ||
                    lsrauthService.inRole(userDetails, userRoles.USER_MANAGEMENT)
                ) {
                    <a class="no-underline" routerLink="/vefstillingar/notendastillingar">
                        <button mat-menu-item>
                            <mat-icon [svgIcon]="'mat_outline:settings'"></mat-icon>
                            <span>{{ 'label_web_settings' | translate }}</span>
                        </button>
                    </a>
                }
            </ng-container>
            <mat-divider class="my-2"></mat-divider>
            <button mat-menu-item (click)="signOut()">
                <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
                <span>Skrá út</span>
            </button>
        </mat-menu>
    </ng-container>
</fuse-vertical-navigation>
<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
    >
        <!-- Navigation toggle button -->
        <button class="mr-2" mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
    </div>
    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>
    <!-- Footer -->
    <div
        class="relative flex flex-0 flex-wrap items-center justify-between w-full min-h-14 pt-2 md:pt-0 pb-2 md:pb-0 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
        [ngClass]="{
            'flex-row-reverse': userDetails?.user?.primaryKennitala == userDetails?.user?.kennitala,
        }"
    >
        <span class="flex flex-wrap gap-x-4 items-center font-medium text-secondary">
            <span>
                <span class="hidden lg:!inline-block"> Snjallari LSR - </span>
                &copy; {{ currentYear }} -
                <span class="italic" matTooltip="{{ 'text_footer_terms' | translate }}">Fyrirvari um birtingu gagna</span>
            </span>
            <span class="flex gap-x-4">
                <a class="no-underline hover:underline" [href]="'info_contact_web_administration_mail' | translate">{{
                    'label_contact_web_administration' | translate
                }}</a>
                <a class="no-underline hover:underline" [href]="'info_contact_lsr' | translate" target="_blank">{{
                    'label_contact_lsr' | translate
                }}</a>
            </span>
        </span>
    </div>
</div>
